const HomePage = () => import('@/views/home')
const LoginPage = () => import('@/views/login')

export const routes = [
  {
    path: '/',
    name: 'main',
    redirect: '/home',
  },
  {
    path: '/home',
    name: 'home',
    meta: {
      title: '首页',
    },
    component: HomePage,
  },
  {
    path: '/login',
    name: 'login',
    component: LoginPage,
  },
]



// WEBPACK FOOTER //
// ./src/router/routes.js